"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_PATH = exports.HOST = void 0;
exports.HOST = process.env.HOST || "https://asiabackend.litlyai.com";
exports.BASE_PATH = exports.HOST + "/api/v1";
